export const ptBR = {
  appName: 'GBFR Save Analytics',
  tagline: 'análise e correção de dados',
  open: 'Abrir save',
  compareWith: 'Comparar com…',
  download: 'Baixar save corrigido',
  downloading: 'Recalculando hash…',
  undoAll: 'Desfazer tudo',
  language: 'Idioma',
  fileInfo: '{name} · {size} MB · {units} unidades',

  navAnalysis: 'Análise',
  navData: 'Dados',
  dashboard: 'Painel',
  characters: 'Personagens',
  sigils: 'Sigilos',
  materials: 'Materiais',
  weapons: 'Armas',
  otherItems: 'Outros itens',
  explore: 'Explorar tudo',
  ids: 'Tabela de IDs',
  compare: 'Comparar',
  changes: 'Alterações',

  welcomeTitle: 'Leia o seu save antes de mexer nele.',
  welcomeBody: 'Abra o SaveData1.dat do Granblue Fantasy: Relink para ver personagens, sigilos, materiais e armas, comparar dois saves e, se quiser, corrigir valores. O arquivo é lido só neste navegador: nada é enviado para servidor algum.',
  dropHere: 'Arraste o SaveData1.dat aqui',
  orChoose: 'ou escolha o arquivo',
  whereIsSave: 'O save fica na pasta SaveGames do jogo, junto com os backups SaveData1_BackUp.dat e SaveData1_BackUp2.dat.',
  step1: 'Abra o save e confira o selo de integridade.',
  step2: 'Analise o painel; compare com um backup se quiser ver o que mudou.',
  step3: 'Edite com cuidado, baixe o save corrigido e substitua com o jogo fechado.',
  readError: 'Não foi possível ler {name}: não parece um save do Relink.',
  configFile: 'Este é um arquivo de configuração, não o save de progresso. Use “Explorar tudo” para ver e editar seus campos.',

  responsibilityTitle: 'Antes de começar',
  responsibilityBody: 'Esta é uma ferramenta de análise e correção de dados. Qualquer alteração que você fizer nos seus arquivos é de sua inteira responsabilidade. Faça sempre um backup do save original antes de substituí-lo.',
  responsibilityPoints1: 'O save é processado só no seu navegador; nada é enviado.',
  responsibilityPoints2: 'Muitos campos têm significado incerto; a confiança de cada um é indicada.',
  responsibilityPoints3: 'Projeto de fãs, sem afiliação com a Cygames.',
  responsibilityAccept: 'Entendi e assumo a responsabilidade',
  footerNotice: 'Ferramenta de análise e correção de dados. Você é inteiramente responsável por qualquer alteração nos seus arquivos. Sem afiliação com a Cygames.',
  downloadNotice: 'Ao baixar, você assume a responsabilidade pelas alterações. Feche o jogo e guarde o original.',
  namesCredit: 'Nomes: Nenkai/relink-modding',
  namesOffline: 'Sem conexão com a lista de nomes; exibindo IDs.',
  namesLoading: 'Carregando nomes…',
  source: 'Código-fonte',
  madeBy: 'Desenvolvido por',
  music: 'Música tema',
  musicTurnOn: 'Ativar música tema',
  musicTurnOff: 'Desativar música tema',
  sfx: 'Efeitos sonoros',
  sfxTurnOn: 'Ativar efeitos sonoros',
  sfxTurnOff: 'Desativar efeitos sonoros',

  inParty: 'Na equipe atual',
  sigilsWorn: 'Sigilos equipados',
  noWeapons: 'Nenhuma arma deste personagem no save.',
  noSigils: 'Nenhum sigilo equipado.',
  sheetNote: 'Valores lidos do save. Para alterá-los, use a tabela de edição.',
  editCharacter: 'Editar personagem',
  prevChar: 'Personagem anterior',
  nextChar: 'Próximo personagem',
  close: 'Fechar',

  sealOk: 'Hash verificado',
  sealBad: 'Hash inválido',
  sealFixed: 'Hash recalculado',
  sealNone: 'Sem hash',
  sealOkBody: 'A integridade XXHash64 (nº {index}) confere com o arquivo.',
  sealBadBody: 'O hash nº {index} não confere; o jogo diria que o save está corrompido. Ele será corrigido ao baixar.',
  sealFixedBody: 'Hash nº {index} recalculado para as suas alterações.',
  sealNoneBody: 'Este arquivo não tem hash de integridade.',
  sealPending: 'Hash pendente',
  stamp_ok: 'válido', stamp_bad: 'falha', stamp_fixed: 'novo', stamp_pending: 'pendente', stamp_none: 'sem hash',
  sealPendingBody: 'Há alterações; o hash será recalculado ao baixar.',
  confidence: 'Confiança',
  confirmed: 'confirmado',
  likely: 'provável',
  possible: 'possível',
  unknown: 'desconhecido',

  rupies: 'Rupies',
  maxedChars: 'Nível 100',
  unknownChar: 'Personagem desconhecido',
  maxShort: 'MAX',
  noOwner: 'Sem dono identificado',
  howItWorks: 'Como funciona',
  analysis: 'Análise do save',
  charEditTitle: 'Editar personagens',
  forGame: 'para Granblue Fantasy: Relink',
  artCredit: 'Artes e logotipo © Cygames, usados em projeto de fãs.',
  sigilCount: 'Sigilos',
  materialKinds: 'Materiais',
  weaponCount: 'Armas',
  sinceCompare: '{delta} desde {name}',
  playerName: 'Protagonista',
  profileName: 'Nome de perfil',
  party: 'Grupo atual',
  lastSaved: 'Salvo em',

  charProgress: 'Progresso dos personagens',
  charProgressNote: 'Nível de cada personagem recrutado; ouro = nível máximo.',
  level: 'Nível',
  exp: 'EXP',
  hp: 'HP',
  atk: 'Ataque',
  msp: 'MSP',
  progress: 'Progresso',
  character: 'Personagem',
  charEditNote: 'Ao mudar o nível, ajuste a EXP junto (nível 100 = 8.400.000), senão o jogo pode recalcular. HP, Ataque e MSP são suposições.',

  sigilLevels: 'Sigilos por nível',
  topSigils: 'Sigilos mais numerosos',
  sigilsByChar: 'Sigilos equipados por personagem',
  sigil: 'Sigilo',
  wornBy: 'Equipado em',
  serial: 'Série',
  count: 'Quantidade',
  duplicates: 'duplicados',

  topMaterials: 'Materiais mais abundantes',
  scarceMaterials: 'Materiais quase esgotados',
  material: 'Material',
  quantity: 'Quantidade',

  weaponsByChar: 'Armas por personagem',
  weapon: 'Arma',
  owner: 'Dono',
  uncap: 'Uncap',
  awakening: 'Despertar',
  wrightstone: 'Wrightstone',
  appearance: 'Aparência',

  evolution: 'Evolução entre saves',
  evolutionEmpty: 'Abra um segundo save em “Comparar com…” (por exemplo o SaveData1_BackUp2.dat) para ver o que você ganhou, gastou e evoluiu.',
  rupiesDelta: 'Rupies',
  materialDeltas: 'Materiais ganhos e gastos',
  levelUps: 'Níveis ganhos',
  sigilsGained: 'Sigilos a mais',
  weaponsGained: 'Armas a mais',
  gained: 'ganho',
  spent: 'gasto',
  sideA: 'Lado A · {name}',
  sideB: 'Lado B · {name}',

  wrightstones: 'Wrightstones',
  curios: 'Curios',
  list1901: 'Lista 1901 (incerta)',

  filter: 'Filtrar por nome ou ID…',
  filterValue: 'Valor, nome ou descrição…',
  shown: '{shown} de {total}',
  tooMany: '{total} unidades; mostrando {shown}. Refine o filtro.',
  allTypes: 'todos os tipos',
  allSections: 'todas as seções',
  onlyNonZero: 'só não-zero',
  section: 'seção',
  type: 'tipo',
  value: 'valor',
  description: 'descrição',
  edit: 'editar',
  showing: 'Mostrando {n} de {total} valores.',
  empty: '(vazio)',
  none: '—',
  viewTable: 'Ver como tabela',

  idsIntro: 'Cada id é um tipo de dado; o unit separa as entradas (um item, um personagem…). Suas anotações ficam salvas neste navegador.',
  group: 'grupo',
  note: 'anotação',
  notePlaceholder: 'sua anotação…',
  onlyDescribed: 'só com descrição ou anotação',
  exportNotes: 'Exportar anotações',
  importNotes: 'Importar anotações',
  importError: 'Não foi possível importar: {msg}',
  view: 'ver',
  example: 'exemplo',
  noDescription: 'sem descrição',

  compareIntro: 'Escolha outro save em “Comparar com…”. Dica: copie o save, faça uma única ação no jogo, salve e compare para descobrir um ID.',
  differences: 'Diferenças: {a} → {b} ({n})',
  refersTo: 'refere-se a',
  change: 'mudança',
  compareFirst: 'Abra primeiro o save principal.',

  changesTitle: 'Alterações pendentes ({n})',
  noChanges: 'Nenhuma alteração ainda.',
  field: 'campo',
  undo: 'desfazer',
  changesHelp: 'Para aplicar: clique em “Baixar save corrigido”, feche o jogo e substitua o {name} na pasta de saves, guardando o original. O arquivo baixado tem o mesmo tamanho; mudam só os bytes editados e o hash de integridade.',

  errNan: 'Não é um número.',
  errInt: 'Precisa ser um número inteiro.',
  errRange: 'Fora do intervalo {lo}..{hi}.',
  unsavedWarning: 'Há alterações não baixadas.',

  groupplayer: 'Jogador', groupprogress: 'Progresso', groupintegrity: 'Integridade', groupworld: 'Mundo', groupdates: 'Datas',
  grouponline: 'Online', groupparty: 'Party', groupcharacters: 'Personagens', groupmaterials: 'Materiais', groupitems: 'Itens',
  groupwrightstones: 'Wrightstones', groupsigils: 'Sigilos', groupweapons: 'Armas', groupcollection: 'Coleção', grouploadscreen: 'Tela de carregar',
};
